import types from './types'

const updateCollegeCompare = (payload) => (dispatch) =>
  new Promise((resolve) => {
    dispatch({
      type: types.UPDATE_COLLEGE_COMPARE,
      payload,
    })
    return resolve(payload)
  })

const clearCollegeCompare = () => (dispatch) =>
  dispatch({
    type: types.CLEAR_COLLEGE_COMPARE,
  })

const actions = {
  updateCollegeCompare,
  clearCollegeCompare,
}

export default actions
